const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.tagsView.visitedViews,
  operateData: state => state.dataOperate.operateData,
  role: state => state.role,
  user: state => state.user
}
export default getters
